/**
 * @zendir/ui — CSS variable name constants
 *
 * AUTO-GENERATED from src/tokens/tokens.css. DO NOT EDIT BY HAND.
 * Regenerate with: npm run build:tokens
 *
 * Use these instead of writing `var("--zendir-…")` literally — typos
 * become compile errors, refactors are safe, and renames propagate.
 *
 * Example:
 *   import { CSS_VAR_FONT_PRIMARY } from "@zendir/ui/tokens/css-vars";
 *   const style = { fontFamily: `var(${CSS_VAR_FONT_PRIMARY})` };
 */

export const CSS_VAR_ACCENT_PRIMARY = "--zendir-accent-primary" as const;
export const CSS_VAR_ACCENT_SECONDARY = "--zendir-accent-secondary" as const;
export const CSS_VAR_ACCENT_TERTIARY = "--zendir-accent-tertiary" as const;
export const CSS_VAR_ANIMATION_FAST = "--zendir-animation-fast" as const;
export const CSS_VAR_ANIMATION_NORMAL = "--zendir-animation-normal" as const;
export const CSS_VAR_ANIMATION_SLOW = "--zendir-animation-slow" as const;
export const CSS_VAR_ASTRO_AMBER_400 = "--zendir-astro-amber-400" as const;
export const CSS_VAR_ASTRO_AMBER_500 = "--zendir-astro-amber-500" as const;
export const CSS_VAR_ASTRO_AMBER_600 = "--zendir-astro-amber-600" as const;
export const CSS_VAR_ASTRO_AMBER_700 = "--zendir-astro-amber-700" as const;
export const CSS_VAR_ASTRO_AMBER_800 = "--zendir-astro-amber-800" as const;
export const CSS_VAR_ASTRO_AMBER_900 = "--zendir-astro-amber-900" as const;
export const CSS_VAR_ASTRO_CYAN_400 = "--zendir-astro-cyan-400" as const;
export const CSS_VAR_ASTRO_CYAN_500 = "--zendir-astro-cyan-500" as const;
export const CSS_VAR_ASTRO_CYAN_600 = "--zendir-astro-cyan-600" as const;
export const CSS_VAR_ASTRO_CYAN_700 = "--zendir-astro-cyan-700" as const;
export const CSS_VAR_ASTRO_CYAN_800 = "--zendir-astro-cyan-800" as const;
export const CSS_VAR_ASTRO_CYAN_900 = "--zendir-astro-cyan-900" as const;
export const CSS_VAR_ASTRO_GREEN_400 = "--zendir-astro-green-400" as const;
export const CSS_VAR_ASTRO_GREEN_500 = "--zendir-astro-green-500" as const;
export const CSS_VAR_ASTRO_GREEN_600 = "--zendir-astro-green-600" as const;
export const CSS_VAR_ASTRO_GREEN_700 = "--zendir-astro-green-700" as const;
export const CSS_VAR_ASTRO_GREEN_800 = "--zendir-astro-green-800" as const;
export const CSS_VAR_ASTRO_GREEN_900 = "--zendir-astro-green-900" as const;
export const CSS_VAR_ASTRO_RED_400 = "--zendir-astro-red-400" as const;
export const CSS_VAR_ASTRO_RED_500 = "--zendir-astro-red-500" as const;
export const CSS_VAR_ASTRO_RED_600 = "--zendir-astro-red-600" as const;
export const CSS_VAR_ASTRO_RED_700 = "--zendir-astro-red-700" as const;
export const CSS_VAR_ASTRO_RED_800 = "--zendir-astro-red-800" as const;
export const CSS_VAR_ASTRO_RED_900 = "--zendir-astro-red-900" as const;
export const CSS_VAR_ASTRO_YELLOW_400 = "--zendir-astro-yellow-400" as const;
export const CSS_VAR_ASTRO_YELLOW_500 = "--zendir-astro-yellow-500" as const;
export const CSS_VAR_ASTRO_YELLOW_600 = "--zendir-astro-yellow-600" as const;
export const CSS_VAR_ASTRO_YELLOW_700 = "--zendir-astro-yellow-700" as const;
export const CSS_VAR_ASTRO_YELLOW_800 = "--zendir-astro-yellow-800" as const;
export const CSS_VAR_ASTRO_YELLOW_900 = "--zendir-astro-yellow-900" as const;
export const CSS_VAR_BG_BASE = "--zendir-bg-base" as const;
export const CSS_VAR_BG_ELEVATED = "--zendir-bg-elevated" as const;
export const CSS_VAR_BG_OVERLAY = "--zendir-bg-overlay" as const;
export const CSS_VAR_BG_SURFACE = "--zendir-bg-surface" as const;
export const CSS_VAR_BORDER_DEFAULT = "--zendir-border-default" as const;
export const CSS_VAR_BORDER_FOCUS = "--zendir-border-focus" as const;
export const CSS_VAR_BORDER_MUTED = "--zendir-border-muted" as const;
export const CSS_VAR_EB_100 = "--zendir-eb-100" as const;
export const CSS_VAR_EB_200 = "--zendir-eb-200" as const;
export const CSS_VAR_EB_300 = "--zendir-eb-300" as const;
export const CSS_VAR_EB_400 = "--zendir-eb-400" as const;
export const CSS_VAR_EB_50 = "--zendir-eb-50" as const;
export const CSS_VAR_EB_500 = "--zendir-eb-500" as const;
export const CSS_VAR_EB_600 = "--zendir-eb-600" as const;
export const CSS_VAR_EB_700 = "--zendir-eb-700" as const;
export const CSS_VAR_EB_800 = "--zendir-eb-800" as const;
export const CSS_VAR_EB_900 = "--zendir-eb-900" as const;
export const CSS_VAR_EB_950 = "--zendir-eb-950" as const;
export const CSS_VAR_FONT_HEADING = "--zendir-font-heading" as const;
export const CSS_VAR_FONT_MONO = "--zendir-font-mono" as const;
export const CSS_VAR_FONT_PRIMARY = "--zendir-font-primary" as const;
export const CSS_VAR_FONT_SIZE_BASE = "--zendir-font-size-base" as const;
export const CSS_VAR_FONT_SIZE_DISPLAY = "--zendir-font-size-display" as const;
export const CSS_VAR_FONT_SIZE_LG = "--zendir-font-size-lg" as const;
export const CSS_VAR_FONT_SIZE_MD = "--zendir-font-size-md" as const;
export const CSS_VAR_FONT_SIZE_MICRO = "--zendir-font-size-micro" as const;
export const CSS_VAR_FONT_SIZE_SM = "--zendir-font-size-sm" as const;
export const CSS_VAR_FONT_SIZE_XL = "--zendir-font-size-xl" as const;
export const CSS_VAR_FONT_SIZE_XS = "--zendir-font-size-xs" as const;
export const CSS_VAR_FONT_SIZE_XXL = "--zendir-font-size-xxl" as const;
export const CSS_VAR_FONT_SIZE_XXS = "--zendir-font-size-xxs" as const;
export const CSS_VAR_FONT_SIZE_XXXL = "--zendir-font-size-xxxl" as const;
export const CSS_VAR_FONT_WEIGHT_BOLD = "--zendir-font-weight-bold" as const;
export const CSS_VAR_FONT_WEIGHT_LIGHT = "--zendir-font-weight-light" as const;
export const CSS_VAR_FONT_WEIGHT_MEDIUM =
  "--zendir-font-weight-medium" as const;
export const CSS_VAR_FONT_WEIGHT_NORMAL =
  "--zendir-font-weight-normal" as const;
export const CSS_VAR_FONT_WEIGHT_SEMIBOLD =
  "--zendir-font-weight-semibold" as const;
export const CSS_VAR_LINE_HEIGHT_NORMAL =
  "--zendir-line-height-normal" as const;
export const CSS_VAR_LINE_HEIGHT_RELAXED =
  "--zendir-line-height-relaxed" as const;
export const CSS_VAR_LINE_HEIGHT_TIGHT = "--zendir-line-height-tight" as const;
export const CSS_VAR_NEUTRAL_100 = "--zendir-neutral-100" as const;
export const CSS_VAR_NEUTRAL_200 = "--zendir-neutral-200" as const;
export const CSS_VAR_NEUTRAL_300 = "--zendir-neutral-300" as const;
export const CSS_VAR_NEUTRAL_400 = "--zendir-neutral-400" as const;
export const CSS_VAR_NEUTRAL_50 = "--zendir-neutral-50" as const;
export const CSS_VAR_NEUTRAL_500 = "--zendir-neutral-500" as const;
export const CSS_VAR_NEUTRAL_600 = "--zendir-neutral-600" as const;
export const CSS_VAR_NEUTRAL_700 = "--zendir-neutral-700" as const;
export const CSS_VAR_NEUTRAL_800 = "--zendir-neutral-800" as const;
export const CSS_VAR_NEUTRAL_900 = "--zendir-neutral-900" as const;
export const CSS_VAR_NEUTRAL_950 = "--zendir-neutral-950" as const;
export const CSS_VAR_PB_100 = "--zendir-pb-100" as const;
export const CSS_VAR_PB_200 = "--zendir-pb-200" as const;
export const CSS_VAR_PB_300 = "--zendir-pb-300" as const;
export const CSS_VAR_PB_400 = "--zendir-pb-400" as const;
export const CSS_VAR_PB_50 = "--zendir-pb-50" as const;
export const CSS_VAR_PB_500 = "--zendir-pb-500" as const;
export const CSS_VAR_PB_600 = "--zendir-pb-600" as const;
export const CSS_VAR_PB_700 = "--zendir-pb-700" as const;
export const CSS_VAR_PB_800 = "--zendir-pb-800" as const;
export const CSS_VAR_PB_900 = "--zendir-pb-900" as const;
export const CSS_VAR_PB_950 = "--zendir-pb-950" as const;
export const CSS_VAR_RADIUS_FULL = "--zendir-radius-full" as const;
export const CSS_VAR_RADIUS_LG = "--zendir-radius-lg" as const;
export const CSS_VAR_RADIUS_MD = "--zendir-radius-md" as const;
export const CSS_VAR_RADIUS_NONE = "--zendir-radius-none" as const;
export const CSS_VAR_RADIUS_SM = "--zendir-radius-sm" as const;
export const CSS_VAR_RADIUS_XL = "--zendir-radius-xl" as const;
export const CSS_VAR_SEMANTIC_ERROR = "--zendir-semantic-error" as const;
export const CSS_VAR_SEMANTIC_INFO = "--zendir-semantic-info" as const;
export const CSS_VAR_SEMANTIC_SUCCESS = "--zendir-semantic-success" as const;
export const CSS_VAR_SEMANTIC_WARNING = "--zendir-semantic-warning" as const;
export const CSS_VAR_SHADOW_GLOW = "--zendir-shadow-glow" as const;
export const CSS_VAR_SHADOW_LG = "--zendir-shadow-lg" as const;
export const CSS_VAR_SHADOW_MD = "--zendir-shadow-md" as const;
export const CSS_VAR_SHADOW_NONE = "--zendir-shadow-none" as const;
export const CSS_VAR_SHADOW_SM = "--zendir-shadow-sm" as const;
export const CSS_VAR_SHADOW_XL = "--zendir-shadow-xl" as const;
export const CSS_VAR_SPACING_LG = "--zendir-spacing-lg" as const;
export const CSS_VAR_SPACING_MD = "--zendir-spacing-md" as const;
export const CSS_VAR_SPACING_SM = "--zendir-spacing-sm" as const;
export const CSS_VAR_SPACING_XL = "--zendir-spacing-xl" as const;
export const CSS_VAR_SPACING_XS = "--zendir-spacing-xs" as const;
export const CSS_VAR_SPACING_XXL = "--zendir-spacing-xxl" as const;
export const CSS_VAR_STATUS_CAUTION = "--zendir-status-caution" as const;
export const CSS_VAR_STATUS_CAUTION_BORDER =
  "--zendir-status-caution-border" as const;
export const CSS_VAR_STATUS_CAUTION_LIGHT =
  "--zendir-status-caution-light" as const;
export const CSS_VAR_STATUS_CRITICAL = "--zendir-status-critical" as const;
export const CSS_VAR_STATUS_CRITICAL_BORDER =
  "--zendir-status-critical-border" as const;
export const CSS_VAR_STATUS_CRITICAL_LIGHT =
  "--zendir-status-critical-light" as const;
export const CSS_VAR_STATUS_NORMAL = "--zendir-status-normal" as const;
export const CSS_VAR_STATUS_NORMAL_BORDER =
  "--zendir-status-normal-border" as const;
export const CSS_VAR_STATUS_NORMAL_LIGHT =
  "--zendir-status-normal-light" as const;
export const CSS_VAR_STATUS_OFF = "--zendir-status-off" as const;
export const CSS_VAR_STATUS_OFF_BORDER = "--zendir-status-off-border" as const;
export const CSS_VAR_STATUS_OFF_LIGHT = "--zendir-status-off-light" as const;
export const CSS_VAR_STATUS_SERIOUS = "--zendir-status-serious" as const;
export const CSS_VAR_STATUS_SERIOUS_BORDER =
  "--zendir-status-serious-border" as const;
export const CSS_VAR_STATUS_SERIOUS_LIGHT =
  "--zendir-status-serious-light" as const;
export const CSS_VAR_STATUS_STANDBY = "--zendir-status-standby" as const;
export const CSS_VAR_STATUS_STANDBY_BORDER =
  "--zendir-status-standby-border" as const;
export const CSS_VAR_STATUS_STANDBY_LIGHT =
  "--zendir-status-standby-light" as const;
export const CSS_VAR_TEXT_MUTED = "--zendir-text-muted" as const;
export const CSS_VAR_TEXT_PRIMARY = "--zendir-text-primary" as const;
export const CSS_VAR_TEXT_SECONDARY = "--zendir-text-secondary" as const;
export const CSS_VAR_TEXT_TERTIARY = "--zendir-text-tertiary" as const;
export const CSS_VAR_TW_BLUE_100 = "--zendir-tw-blue-100" as const;
export const CSS_VAR_TW_BLUE_200 = "--zendir-tw-blue-200" as const;
export const CSS_VAR_TW_BLUE_300 = "--zendir-tw-blue-300" as const;
export const CSS_VAR_TW_BLUE_400 = "--zendir-tw-blue-400" as const;
export const CSS_VAR_TW_BLUE_50 = "--zendir-tw-blue-50" as const;
export const CSS_VAR_TW_BLUE_500 = "--zendir-tw-blue-500" as const;
export const CSS_VAR_TW_BLUE_600 = "--zendir-tw-blue-600" as const;
export const CSS_VAR_TW_BLUE_700 = "--zendir-tw-blue-700" as const;
export const CSS_VAR_TW_BLUE_800 = "--zendir-tw-blue-800" as const;
export const CSS_VAR_TW_BLUE_900 = "--zendir-tw-blue-900" as const;
export const CSS_VAR_TW_BLUE_950 = "--zendir-tw-blue-950" as const;
export const CSS_VAR_TW_GREEN_100 = "--zendir-tw-green-100" as const;
export const CSS_VAR_TW_GREEN_200 = "--zendir-tw-green-200" as const;
export const CSS_VAR_TW_GREEN_300 = "--zendir-tw-green-300" as const;
export const CSS_VAR_TW_GREEN_400 = "--zendir-tw-green-400" as const;
export const CSS_VAR_TW_GREEN_50 = "--zendir-tw-green-50" as const;
export const CSS_VAR_TW_GREEN_500 = "--zendir-tw-green-500" as const;
export const CSS_VAR_TW_GREEN_600 = "--zendir-tw-green-600" as const;
export const CSS_VAR_TW_GREEN_700 = "--zendir-tw-green-700" as const;
export const CSS_VAR_TW_GREEN_800 = "--zendir-tw-green-800" as const;
export const CSS_VAR_TW_GREEN_900 = "--zendir-tw-green-900" as const;
export const CSS_VAR_TW_GREEN_950 = "--zendir-tw-green-950" as const;
export const CSS_VAR_TW_INDIGO_100 = "--zendir-tw-indigo-100" as const;
export const CSS_VAR_TW_INDIGO_200 = "--zendir-tw-indigo-200" as const;
export const CSS_VAR_TW_INDIGO_300 = "--zendir-tw-indigo-300" as const;
export const CSS_VAR_TW_INDIGO_400 = "--zendir-tw-indigo-400" as const;
export const CSS_VAR_TW_INDIGO_50 = "--zendir-tw-indigo-50" as const;
export const CSS_VAR_TW_INDIGO_500 = "--zendir-tw-indigo-500" as const;
export const CSS_VAR_TW_INDIGO_600 = "--zendir-tw-indigo-600" as const;
export const CSS_VAR_TW_INDIGO_700 = "--zendir-tw-indigo-700" as const;
export const CSS_VAR_TW_INDIGO_800 = "--zendir-tw-indigo-800" as const;
export const CSS_VAR_TW_INDIGO_900 = "--zendir-tw-indigo-900" as const;
export const CSS_VAR_TW_INDIGO_950 = "--zendir-tw-indigo-950" as const;
export const CSS_VAR_TW_NEUTRAL_100 = "--zendir-tw-neutral-100" as const;
export const CSS_VAR_TW_NEUTRAL_200 = "--zendir-tw-neutral-200" as const;
export const CSS_VAR_TW_NEUTRAL_300 = "--zendir-tw-neutral-300" as const;
export const CSS_VAR_TW_NEUTRAL_400 = "--zendir-tw-neutral-400" as const;
export const CSS_VAR_TW_NEUTRAL_50 = "--zendir-tw-neutral-50" as const;
export const CSS_VAR_TW_NEUTRAL_500 = "--zendir-tw-neutral-500" as const;
export const CSS_VAR_TW_NEUTRAL_600 = "--zendir-tw-neutral-600" as const;
export const CSS_VAR_TW_NEUTRAL_700 = "--zendir-tw-neutral-700" as const;
export const CSS_VAR_TW_NEUTRAL_800 = "--zendir-tw-neutral-800" as const;
export const CSS_VAR_TW_NEUTRAL_900 = "--zendir-tw-neutral-900" as const;
export const CSS_VAR_TW_NEUTRAL_950 = "--zendir-tw-neutral-950" as const;
export const CSS_VAR_TW_ORANGE_100 = "--zendir-tw-orange-100" as const;
export const CSS_VAR_TW_ORANGE_200 = "--zendir-tw-orange-200" as const;
export const CSS_VAR_TW_ORANGE_300 = "--zendir-tw-orange-300" as const;
export const CSS_VAR_TW_ORANGE_400 = "--zendir-tw-orange-400" as const;
export const CSS_VAR_TW_ORANGE_50 = "--zendir-tw-orange-50" as const;
export const CSS_VAR_TW_ORANGE_500 = "--zendir-tw-orange-500" as const;
export const CSS_VAR_TW_ORANGE_600 = "--zendir-tw-orange-600" as const;
export const CSS_VAR_TW_ORANGE_700 = "--zendir-tw-orange-700" as const;
export const CSS_VAR_TW_ORANGE_800 = "--zendir-tw-orange-800" as const;
export const CSS_VAR_TW_ORANGE_900 = "--zendir-tw-orange-900" as const;
export const CSS_VAR_TW_ORANGE_950 = "--zendir-tw-orange-950" as const;
export const CSS_VAR_TW_PINK_100 = "--zendir-tw-pink-100" as const;
export const CSS_VAR_TW_PINK_200 = "--zendir-tw-pink-200" as const;
export const CSS_VAR_TW_PINK_300 = "--zendir-tw-pink-300" as const;
export const CSS_VAR_TW_PINK_400 = "--zendir-tw-pink-400" as const;
export const CSS_VAR_TW_PINK_50 = "--zendir-tw-pink-50" as const;
export const CSS_VAR_TW_PINK_500 = "--zendir-tw-pink-500" as const;
export const CSS_VAR_TW_PINK_600 = "--zendir-tw-pink-600" as const;
export const CSS_VAR_TW_PINK_700 = "--zendir-tw-pink-700" as const;
export const CSS_VAR_TW_PINK_800 = "--zendir-tw-pink-800" as const;
export const CSS_VAR_TW_PINK_900 = "--zendir-tw-pink-900" as const;
export const CSS_VAR_TW_PINK_950 = "--zendir-tw-pink-950" as const;
export const CSS_VAR_TW_PURPLE_100 = "--zendir-tw-purple-100" as const;
export const CSS_VAR_TW_PURPLE_200 = "--zendir-tw-purple-200" as const;
export const CSS_VAR_TW_PURPLE_300 = "--zendir-tw-purple-300" as const;
export const CSS_VAR_TW_PURPLE_400 = "--zendir-tw-purple-400" as const;
export const CSS_VAR_TW_PURPLE_50 = "--zendir-tw-purple-50" as const;
export const CSS_VAR_TW_PURPLE_500 = "--zendir-tw-purple-500" as const;
export const CSS_VAR_TW_PURPLE_600 = "--zendir-tw-purple-600" as const;
export const CSS_VAR_TW_PURPLE_700 = "--zendir-tw-purple-700" as const;
export const CSS_VAR_TW_PURPLE_800 = "--zendir-tw-purple-800" as const;
export const CSS_VAR_TW_PURPLE_900 = "--zendir-tw-purple-900" as const;
export const CSS_VAR_TW_PURPLE_950 = "--zendir-tw-purple-950" as const;
export const CSS_VAR_TW_RED_100 = "--zendir-tw-red-100" as const;
export const CSS_VAR_TW_RED_200 = "--zendir-tw-red-200" as const;
export const CSS_VAR_TW_RED_300 = "--zendir-tw-red-300" as const;
export const CSS_VAR_TW_RED_400 = "--zendir-tw-red-400" as const;
export const CSS_VAR_TW_RED_50 = "--zendir-tw-red-50" as const;
export const CSS_VAR_TW_RED_500 = "--zendir-tw-red-500" as const;
export const CSS_VAR_TW_RED_600 = "--zendir-tw-red-600" as const;
export const CSS_VAR_TW_RED_700 = "--zendir-tw-red-700" as const;
export const CSS_VAR_TW_RED_800 = "--zendir-tw-red-800" as const;
export const CSS_VAR_TW_RED_900 = "--zendir-tw-red-900" as const;
export const CSS_VAR_TW_RED_950 = "--zendir-tw-red-950" as const;
export const CSS_VAR_TW_ROSE_100 = "--zendir-tw-rose-100" as const;
export const CSS_VAR_TW_ROSE_200 = "--zendir-tw-rose-200" as const;
export const CSS_VAR_TW_ROSE_300 = "--zendir-tw-rose-300" as const;
export const CSS_VAR_TW_ROSE_400 = "--zendir-tw-rose-400" as const;
export const CSS_VAR_TW_ROSE_50 = "--zendir-tw-rose-50" as const;
export const CSS_VAR_TW_ROSE_500 = "--zendir-tw-rose-500" as const;
export const CSS_VAR_TW_ROSE_600 = "--zendir-tw-rose-600" as const;
export const CSS_VAR_TW_ROSE_700 = "--zendir-tw-rose-700" as const;
export const CSS_VAR_TW_ROSE_800 = "--zendir-tw-rose-800" as const;
export const CSS_VAR_TW_ROSE_900 = "--zendir-tw-rose-900" as const;
export const CSS_VAR_TW_ROSE_950 = "--zendir-tw-rose-950" as const;
export const CSS_VAR_TW_SKY_100 = "--zendir-tw-sky-100" as const;
export const CSS_VAR_TW_SKY_200 = "--zendir-tw-sky-200" as const;
export const CSS_VAR_TW_SKY_300 = "--zendir-tw-sky-300" as const;
export const CSS_VAR_TW_SKY_400 = "--zendir-tw-sky-400" as const;
export const CSS_VAR_TW_SKY_50 = "--zendir-tw-sky-50" as const;
export const CSS_VAR_TW_SKY_500 = "--zendir-tw-sky-500" as const;
export const CSS_VAR_TW_SKY_600 = "--zendir-tw-sky-600" as const;
export const CSS_VAR_TW_SKY_700 = "--zendir-tw-sky-700" as const;
export const CSS_VAR_TW_SKY_800 = "--zendir-tw-sky-800" as const;
export const CSS_VAR_TW_SKY_900 = "--zendir-tw-sky-900" as const;
export const CSS_VAR_TW_SKY_950 = "--zendir-tw-sky-950" as const;
export const CSS_VAR_TW_SLATE_100 = "--zendir-tw-slate-100" as const;
export const CSS_VAR_TW_SLATE_200 = "--zendir-tw-slate-200" as const;
export const CSS_VAR_TW_SLATE_300 = "--zendir-tw-slate-300" as const;
export const CSS_VAR_TW_SLATE_400 = "--zendir-tw-slate-400" as const;
export const CSS_VAR_TW_SLATE_50 = "--zendir-tw-slate-50" as const;
export const CSS_VAR_TW_SLATE_500 = "--zendir-tw-slate-500" as const;
export const CSS_VAR_TW_SLATE_600 = "--zendir-tw-slate-600" as const;
export const CSS_VAR_TW_SLATE_700 = "--zendir-tw-slate-700" as const;
export const CSS_VAR_TW_SLATE_800 = "--zendir-tw-slate-800" as const;
export const CSS_VAR_TW_SLATE_900 = "--zendir-tw-slate-900" as const;
export const CSS_VAR_TW_SLATE_950 = "--zendir-tw-slate-950" as const;
export const CSS_VAR_TW_YELLOW_100 = "--zendir-tw-yellow-100" as const;
export const CSS_VAR_TW_YELLOW_200 = "--zendir-tw-yellow-200" as const;
export const CSS_VAR_TW_YELLOW_300 = "--zendir-tw-yellow-300" as const;
export const CSS_VAR_TW_YELLOW_400 = "--zendir-tw-yellow-400" as const;
export const CSS_VAR_TW_YELLOW_50 = "--zendir-tw-yellow-50" as const;
export const CSS_VAR_TW_YELLOW_500 = "--zendir-tw-yellow-500" as const;
export const CSS_VAR_TW_YELLOW_600 = "--zendir-tw-yellow-600" as const;
export const CSS_VAR_TW_YELLOW_700 = "--zendir-tw-yellow-700" as const;
export const CSS_VAR_TW_YELLOW_800 = "--zendir-tw-yellow-800" as const;
export const CSS_VAR_TW_YELLOW_900 = "--zendir-tw-yellow-900" as const;
export const CSS_VAR_TW_YELLOW_950 = "--zendir-tw-yellow-950" as const;
export const CSS_VAR_UV_100 = "--zendir-uv-100" as const;
export const CSS_VAR_UV_200 = "--zendir-uv-200" as const;
export const CSS_VAR_UV_300 = "--zendir-uv-300" as const;
export const CSS_VAR_UV_400 = "--zendir-uv-400" as const;
export const CSS_VAR_UV_50 = "--zendir-uv-50" as const;
export const CSS_VAR_UV_500 = "--zendir-uv-500" as const;
export const CSS_VAR_UV_600 = "--zendir-uv-600" as const;
export const CSS_VAR_UV_700 = "--zendir-uv-700" as const;
export const CSS_VAR_UV_800 = "--zendir-uv-800" as const;
export const CSS_VAR_UV_900 = "--zendir-uv-900" as const;
export const CSS_VAR_UV_950 = "--zendir-uv-950" as const;

/** Union of every Zendir CSS variable name. Useful for `as ZendirCSSVar`. */
export type ZendirCSSVar =
  | "--zendir-accent-primary"
  | "--zendir-accent-secondary"
  | "--zendir-accent-tertiary"
  | "--zendir-animation-fast"
  | "--zendir-animation-normal"
  | "--zendir-animation-slow"
  | "--zendir-astro-amber-400"
  | "--zendir-astro-amber-500"
  | "--zendir-astro-amber-600"
  | "--zendir-astro-amber-700"
  | "--zendir-astro-amber-800"
  | "--zendir-astro-amber-900"
  | "--zendir-astro-cyan-400"
  | "--zendir-astro-cyan-500"
  | "--zendir-astro-cyan-600"
  | "--zendir-astro-cyan-700"
  | "--zendir-astro-cyan-800"
  | "--zendir-astro-cyan-900"
  | "--zendir-astro-green-400"
  | "--zendir-astro-green-500"
  | "--zendir-astro-green-600"
  | "--zendir-astro-green-700"
  | "--zendir-astro-green-800"
  | "--zendir-astro-green-900"
  | "--zendir-astro-red-400"
  | "--zendir-astro-red-500"
  | "--zendir-astro-red-600"
  | "--zendir-astro-red-700"
  | "--zendir-astro-red-800"
  | "--zendir-astro-red-900"
  | "--zendir-astro-yellow-400"
  | "--zendir-astro-yellow-500"
  | "--zendir-astro-yellow-600"
  | "--zendir-astro-yellow-700"
  | "--zendir-astro-yellow-800"
  | "--zendir-astro-yellow-900"
  | "--zendir-bg-base"
  | "--zendir-bg-elevated"
  | "--zendir-bg-overlay"
  | "--zendir-bg-surface"
  | "--zendir-border-default"
  | "--zendir-border-focus"
  | "--zendir-border-muted"
  | "--zendir-eb-100"
  | "--zendir-eb-200"
  | "--zendir-eb-300"
  | "--zendir-eb-400"
  | "--zendir-eb-50"
  | "--zendir-eb-500"
  | "--zendir-eb-600"
  | "--zendir-eb-700"
  | "--zendir-eb-800"
  | "--zendir-eb-900"
  | "--zendir-eb-950"
  | "--zendir-font-heading"
  | "--zendir-font-mono"
  | "--zendir-font-primary"
  | "--zendir-font-size-base"
  | "--zendir-font-size-display"
  | "--zendir-font-size-lg"
  | "--zendir-font-size-md"
  | "--zendir-font-size-micro"
  | "--zendir-font-size-sm"
  | "--zendir-font-size-xl"
  | "--zendir-font-size-xs"
  | "--zendir-font-size-xxl"
  | "--zendir-font-size-xxs"
  | "--zendir-font-size-xxxl"
  | "--zendir-font-weight-bold"
  | "--zendir-font-weight-light"
  | "--zendir-font-weight-medium"
  | "--zendir-font-weight-normal"
  | "--zendir-font-weight-semibold"
  | "--zendir-line-height-normal"
  | "--zendir-line-height-relaxed"
  | "--zendir-line-height-tight"
  | "--zendir-neutral-100"
  | "--zendir-neutral-200"
  | "--zendir-neutral-300"
  | "--zendir-neutral-400"
  | "--zendir-neutral-50"
  | "--zendir-neutral-500"
  | "--zendir-neutral-600"
  | "--zendir-neutral-700"
  | "--zendir-neutral-800"
  | "--zendir-neutral-900"
  | "--zendir-neutral-950"
  | "--zendir-pb-100"
  | "--zendir-pb-200"
  | "--zendir-pb-300"
  | "--zendir-pb-400"
  | "--zendir-pb-50"
  | "--zendir-pb-500"
  | "--zendir-pb-600"
  | "--zendir-pb-700"
  | "--zendir-pb-800"
  | "--zendir-pb-900"
  | "--zendir-pb-950"
  | "--zendir-radius-full"
  | "--zendir-radius-lg"
  | "--zendir-radius-md"
  | "--zendir-radius-none"
  | "--zendir-radius-sm"
  | "--zendir-radius-xl"
  | "--zendir-semantic-error"
  | "--zendir-semantic-info"
  | "--zendir-semantic-success"
  | "--zendir-semantic-warning"
  | "--zendir-shadow-glow"
  | "--zendir-shadow-lg"
  | "--zendir-shadow-md"
  | "--zendir-shadow-none"
  | "--zendir-shadow-sm"
  | "--zendir-shadow-xl"
  | "--zendir-spacing-lg"
  | "--zendir-spacing-md"
  | "--zendir-spacing-sm"
  | "--zendir-spacing-xl"
  | "--zendir-spacing-xs"
  | "--zendir-spacing-xxl"
  | "--zendir-status-caution"
  | "--zendir-status-caution-border"
  | "--zendir-status-caution-light"
  | "--zendir-status-critical"
  | "--zendir-status-critical-border"
  | "--zendir-status-critical-light"
  | "--zendir-status-normal"
  | "--zendir-status-normal-border"
  | "--zendir-status-normal-light"
  | "--zendir-status-off"
  | "--zendir-status-off-border"
  | "--zendir-status-off-light"
  | "--zendir-status-serious"
  | "--zendir-status-serious-border"
  | "--zendir-status-serious-light"
  | "--zendir-status-standby"
  | "--zendir-status-standby-border"
  | "--zendir-status-standby-light"
  | "--zendir-text-muted"
  | "--zendir-text-primary"
  | "--zendir-text-secondary"
  | "--zendir-text-tertiary"
  | "--zendir-tw-blue-100"
  | "--zendir-tw-blue-200"
  | "--zendir-tw-blue-300"
  | "--zendir-tw-blue-400"
  | "--zendir-tw-blue-50"
  | "--zendir-tw-blue-500"
  | "--zendir-tw-blue-600"
  | "--zendir-tw-blue-700"
  | "--zendir-tw-blue-800"
  | "--zendir-tw-blue-900"
  | "--zendir-tw-blue-950"
  | "--zendir-tw-green-100"
  | "--zendir-tw-green-200"
  | "--zendir-tw-green-300"
  | "--zendir-tw-green-400"
  | "--zendir-tw-green-50"
  | "--zendir-tw-green-500"
  | "--zendir-tw-green-600"
  | "--zendir-tw-green-700"
  | "--zendir-tw-green-800"
  | "--zendir-tw-green-900"
  | "--zendir-tw-green-950"
  | "--zendir-tw-indigo-100"
  | "--zendir-tw-indigo-200"
  | "--zendir-tw-indigo-300"
  | "--zendir-tw-indigo-400"
  | "--zendir-tw-indigo-50"
  | "--zendir-tw-indigo-500"
  | "--zendir-tw-indigo-600"
  | "--zendir-tw-indigo-700"
  | "--zendir-tw-indigo-800"
  | "--zendir-tw-indigo-900"
  | "--zendir-tw-indigo-950"
  | "--zendir-tw-neutral-100"
  | "--zendir-tw-neutral-200"
  | "--zendir-tw-neutral-300"
  | "--zendir-tw-neutral-400"
  | "--zendir-tw-neutral-50"
  | "--zendir-tw-neutral-500"
  | "--zendir-tw-neutral-600"
  | "--zendir-tw-neutral-700"
  | "--zendir-tw-neutral-800"
  | "--zendir-tw-neutral-900"
  | "--zendir-tw-neutral-950"
  | "--zendir-tw-orange-100"
  | "--zendir-tw-orange-200"
  | "--zendir-tw-orange-300"
  | "--zendir-tw-orange-400"
  | "--zendir-tw-orange-50"
  | "--zendir-tw-orange-500"
  | "--zendir-tw-orange-600"
  | "--zendir-tw-orange-700"
  | "--zendir-tw-orange-800"
  | "--zendir-tw-orange-900"
  | "--zendir-tw-orange-950"
  | "--zendir-tw-pink-100"
  | "--zendir-tw-pink-200"
  | "--zendir-tw-pink-300"
  | "--zendir-tw-pink-400"
  | "--zendir-tw-pink-50"
  | "--zendir-tw-pink-500"
  | "--zendir-tw-pink-600"
  | "--zendir-tw-pink-700"
  | "--zendir-tw-pink-800"
  | "--zendir-tw-pink-900"
  | "--zendir-tw-pink-950"
  | "--zendir-tw-purple-100"
  | "--zendir-tw-purple-200"
  | "--zendir-tw-purple-300"
  | "--zendir-tw-purple-400"
  | "--zendir-tw-purple-50"
  | "--zendir-tw-purple-500"
  | "--zendir-tw-purple-600"
  | "--zendir-tw-purple-700"
  | "--zendir-tw-purple-800"
  | "--zendir-tw-purple-900"
  | "--zendir-tw-purple-950"
  | "--zendir-tw-red-100"
  | "--zendir-tw-red-200"
  | "--zendir-tw-red-300"
  | "--zendir-tw-red-400"
  | "--zendir-tw-red-50"
  | "--zendir-tw-red-500"
  | "--zendir-tw-red-600"
  | "--zendir-tw-red-700"
  | "--zendir-tw-red-800"
  | "--zendir-tw-red-900"
  | "--zendir-tw-red-950"
  | "--zendir-tw-rose-100"
  | "--zendir-tw-rose-200"
  | "--zendir-tw-rose-300"
  | "--zendir-tw-rose-400"
  | "--zendir-tw-rose-50"
  | "--zendir-tw-rose-500"
  | "--zendir-tw-rose-600"
  | "--zendir-tw-rose-700"
  | "--zendir-tw-rose-800"
  | "--zendir-tw-rose-900"
  | "--zendir-tw-rose-950"
  | "--zendir-tw-sky-100"
  | "--zendir-tw-sky-200"
  | "--zendir-tw-sky-300"
  | "--zendir-tw-sky-400"
  | "--zendir-tw-sky-50"
  | "--zendir-tw-sky-500"
  | "--zendir-tw-sky-600"
  | "--zendir-tw-sky-700"
  | "--zendir-tw-sky-800"
  | "--zendir-tw-sky-900"
  | "--zendir-tw-sky-950"
  | "--zendir-tw-slate-100"
  | "--zendir-tw-slate-200"
  | "--zendir-tw-slate-300"
  | "--zendir-tw-slate-400"
  | "--zendir-tw-slate-50"
  | "--zendir-tw-slate-500"
  | "--zendir-tw-slate-600"
  | "--zendir-tw-slate-700"
  | "--zendir-tw-slate-800"
  | "--zendir-tw-slate-900"
  | "--zendir-tw-slate-950"
  | "--zendir-tw-yellow-100"
  | "--zendir-tw-yellow-200"
  | "--zendir-tw-yellow-300"
  | "--zendir-tw-yellow-400"
  | "--zendir-tw-yellow-50"
  | "--zendir-tw-yellow-500"
  | "--zendir-tw-yellow-600"
  | "--zendir-tw-yellow-700"
  | "--zendir-tw-yellow-800"
  | "--zendir-tw-yellow-900"
  | "--zendir-tw-yellow-950"
  | "--zendir-uv-100"
  | "--zendir-uv-200"
  | "--zendir-uv-300"
  | "--zendir-uv-400"
  | "--zendir-uv-50"
  | "--zendir-uv-500"
  | "--zendir-uv-600"
  | "--zendir-uv-700"
  | "--zendir-uv-800"
  | "--zendir-uv-900"
  | "--zendir-uv-950";

/** Array of every Zendir CSS variable name (alphabetised). */
export const ALL_ZENDIR_CSS_VARS: readonly ZendirCSSVar[] = [
  "--zendir-accent-primary",
  "--zendir-accent-secondary",
  "--zendir-accent-tertiary",
  "--zendir-animation-fast",
  "--zendir-animation-normal",
  "--zendir-animation-slow",
  "--zendir-astro-amber-400",
  "--zendir-astro-amber-500",
  "--zendir-astro-amber-600",
  "--zendir-astro-amber-700",
  "--zendir-astro-amber-800",
  "--zendir-astro-amber-900",
  "--zendir-astro-cyan-400",
  "--zendir-astro-cyan-500",
  "--zendir-astro-cyan-600",
  "--zendir-astro-cyan-700",
  "--zendir-astro-cyan-800",
  "--zendir-astro-cyan-900",
  "--zendir-astro-green-400",
  "--zendir-astro-green-500",
  "--zendir-astro-green-600",
  "--zendir-astro-green-700",
  "--zendir-astro-green-800",
  "--zendir-astro-green-900",
  "--zendir-astro-red-400",
  "--zendir-astro-red-500",
  "--zendir-astro-red-600",
  "--zendir-astro-red-700",
  "--zendir-astro-red-800",
  "--zendir-astro-red-900",
  "--zendir-astro-yellow-400",
  "--zendir-astro-yellow-500",
  "--zendir-astro-yellow-600",
  "--zendir-astro-yellow-700",
  "--zendir-astro-yellow-800",
  "--zendir-astro-yellow-900",
  "--zendir-bg-base",
  "--zendir-bg-elevated",
  "--zendir-bg-overlay",
  "--zendir-bg-surface",
  "--zendir-border-default",
  "--zendir-border-focus",
  "--zendir-border-muted",
  "--zendir-eb-100",
  "--zendir-eb-200",
  "--zendir-eb-300",
  "--zendir-eb-400",
  "--zendir-eb-50",
  "--zendir-eb-500",
  "--zendir-eb-600",
  "--zendir-eb-700",
  "--zendir-eb-800",
  "--zendir-eb-900",
  "--zendir-eb-950",
  "--zendir-font-heading",
  "--zendir-font-mono",
  "--zendir-font-primary",
  "--zendir-font-size-base",
  "--zendir-font-size-display",
  "--zendir-font-size-lg",
  "--zendir-font-size-md",
  "--zendir-font-size-micro",
  "--zendir-font-size-sm",
  "--zendir-font-size-xl",
  "--zendir-font-size-xs",
  "--zendir-font-size-xxl",
  "--zendir-font-size-xxs",
  "--zendir-font-size-xxxl",
  "--zendir-font-weight-bold",
  "--zendir-font-weight-light",
  "--zendir-font-weight-medium",
  "--zendir-font-weight-normal",
  "--zendir-font-weight-semibold",
  "--zendir-line-height-normal",
  "--zendir-line-height-relaxed",
  "--zendir-line-height-tight",
  "--zendir-neutral-100",
  "--zendir-neutral-200",
  "--zendir-neutral-300",
  "--zendir-neutral-400",
  "--zendir-neutral-50",
  "--zendir-neutral-500",
  "--zendir-neutral-600",
  "--zendir-neutral-700",
  "--zendir-neutral-800",
  "--zendir-neutral-900",
  "--zendir-neutral-950",
  "--zendir-pb-100",
  "--zendir-pb-200",
  "--zendir-pb-300",
  "--zendir-pb-400",
  "--zendir-pb-50",
  "--zendir-pb-500",
  "--zendir-pb-600",
  "--zendir-pb-700",
  "--zendir-pb-800",
  "--zendir-pb-900",
  "--zendir-pb-950",
  "--zendir-radius-full",
  "--zendir-radius-lg",
  "--zendir-radius-md",
  "--zendir-radius-none",
  "--zendir-radius-sm",
  "--zendir-radius-xl",
  "--zendir-semantic-error",
  "--zendir-semantic-info",
  "--zendir-semantic-success",
  "--zendir-semantic-warning",
  "--zendir-shadow-glow",
  "--zendir-shadow-lg",
  "--zendir-shadow-md",
  "--zendir-shadow-none",
  "--zendir-shadow-sm",
  "--zendir-shadow-xl",
  "--zendir-spacing-lg",
  "--zendir-spacing-md",
  "--zendir-spacing-sm",
  "--zendir-spacing-xl",
  "--zendir-spacing-xs",
  "--zendir-spacing-xxl",
  "--zendir-status-caution",
  "--zendir-status-caution-border",
  "--zendir-status-caution-light",
  "--zendir-status-critical",
  "--zendir-status-critical-border",
  "--zendir-status-critical-light",
  "--zendir-status-normal",
  "--zendir-status-normal-border",
  "--zendir-status-normal-light",
  "--zendir-status-off",
  "--zendir-status-off-border",
  "--zendir-status-off-light",
  "--zendir-status-serious",
  "--zendir-status-serious-border",
  "--zendir-status-serious-light",
  "--zendir-status-standby",
  "--zendir-status-standby-border",
  "--zendir-status-standby-light",
  "--zendir-text-muted",
  "--zendir-text-primary",
  "--zendir-text-secondary",
  "--zendir-text-tertiary",
  "--zendir-tw-blue-100",
  "--zendir-tw-blue-200",
  "--zendir-tw-blue-300",
  "--zendir-tw-blue-400",
  "--zendir-tw-blue-50",
  "--zendir-tw-blue-500",
  "--zendir-tw-blue-600",
  "--zendir-tw-blue-700",
  "--zendir-tw-blue-800",
  "--zendir-tw-blue-900",
  "--zendir-tw-blue-950",
  "--zendir-tw-green-100",
  "--zendir-tw-green-200",
  "--zendir-tw-green-300",
  "--zendir-tw-green-400",
  "--zendir-tw-green-50",
  "--zendir-tw-green-500",
  "--zendir-tw-green-600",
  "--zendir-tw-green-700",
  "--zendir-tw-green-800",
  "--zendir-tw-green-900",
  "--zendir-tw-green-950",
  "--zendir-tw-indigo-100",
  "--zendir-tw-indigo-200",
  "--zendir-tw-indigo-300",
  "--zendir-tw-indigo-400",
  "--zendir-tw-indigo-50",
  "--zendir-tw-indigo-500",
  "--zendir-tw-indigo-600",
  "--zendir-tw-indigo-700",
  "--zendir-tw-indigo-800",
  "--zendir-tw-indigo-900",
  "--zendir-tw-indigo-950",
  "--zendir-tw-neutral-100",
  "--zendir-tw-neutral-200",
  "--zendir-tw-neutral-300",
  "--zendir-tw-neutral-400",
  "--zendir-tw-neutral-50",
  "--zendir-tw-neutral-500",
  "--zendir-tw-neutral-600",
  "--zendir-tw-neutral-700",
  "--zendir-tw-neutral-800",
  "--zendir-tw-neutral-900",
  "--zendir-tw-neutral-950",
  "--zendir-tw-orange-100",
  "--zendir-tw-orange-200",
  "--zendir-tw-orange-300",
  "--zendir-tw-orange-400",
  "--zendir-tw-orange-50",
  "--zendir-tw-orange-500",
  "--zendir-tw-orange-600",
  "--zendir-tw-orange-700",
  "--zendir-tw-orange-800",
  "--zendir-tw-orange-900",
  "--zendir-tw-orange-950",
  "--zendir-tw-pink-100",
  "--zendir-tw-pink-200",
  "--zendir-tw-pink-300",
  "--zendir-tw-pink-400",
  "--zendir-tw-pink-50",
  "--zendir-tw-pink-500",
  "--zendir-tw-pink-600",
  "--zendir-tw-pink-700",
  "--zendir-tw-pink-800",
  "--zendir-tw-pink-900",
  "--zendir-tw-pink-950",
  "--zendir-tw-purple-100",
  "--zendir-tw-purple-200",
  "--zendir-tw-purple-300",
  "--zendir-tw-purple-400",
  "--zendir-tw-purple-50",
  "--zendir-tw-purple-500",
  "--zendir-tw-purple-600",
  "--zendir-tw-purple-700",
  "--zendir-tw-purple-800",
  "--zendir-tw-purple-900",
  "--zendir-tw-purple-950",
  "--zendir-tw-red-100",
  "--zendir-tw-red-200",
  "--zendir-tw-red-300",
  "--zendir-tw-red-400",
  "--zendir-tw-red-50",
  "--zendir-tw-red-500",
  "--zendir-tw-red-600",
  "--zendir-tw-red-700",
  "--zendir-tw-red-800",
  "--zendir-tw-red-900",
  "--zendir-tw-red-950",
  "--zendir-tw-rose-100",
  "--zendir-tw-rose-200",
  "--zendir-tw-rose-300",
  "--zendir-tw-rose-400",
  "--zendir-tw-rose-50",
  "--zendir-tw-rose-500",
  "--zendir-tw-rose-600",
  "--zendir-tw-rose-700",
  "--zendir-tw-rose-800",
  "--zendir-tw-rose-900",
  "--zendir-tw-rose-950",
  "--zendir-tw-sky-100",
  "--zendir-tw-sky-200",
  "--zendir-tw-sky-300",
  "--zendir-tw-sky-400",
  "--zendir-tw-sky-50",
  "--zendir-tw-sky-500",
  "--zendir-tw-sky-600",
  "--zendir-tw-sky-700",
  "--zendir-tw-sky-800",
  "--zendir-tw-sky-900",
  "--zendir-tw-sky-950",
  "--zendir-tw-slate-100",
  "--zendir-tw-slate-200",
  "--zendir-tw-slate-300",
  "--zendir-tw-slate-400",
  "--zendir-tw-slate-50",
  "--zendir-tw-slate-500",
  "--zendir-tw-slate-600",
  "--zendir-tw-slate-700",
  "--zendir-tw-slate-800",
  "--zendir-tw-slate-900",
  "--zendir-tw-slate-950",
  "--zendir-tw-yellow-100",
  "--zendir-tw-yellow-200",
  "--zendir-tw-yellow-300",
  "--zendir-tw-yellow-400",
  "--zendir-tw-yellow-50",
  "--zendir-tw-yellow-500",
  "--zendir-tw-yellow-600",
  "--zendir-tw-yellow-700",
  "--zendir-tw-yellow-800",
  "--zendir-tw-yellow-900",
  "--zendir-tw-yellow-950",
  "--zendir-uv-100",
  "--zendir-uv-200",
  "--zendir-uv-300",
  "--zendir-uv-400",
  "--zendir-uv-50",
  "--zendir-uv-500",
  "--zendir-uv-600",
  "--zendir-uv-700",
  "--zendir-uv-800",
  "--zendir-uv-900",
  "--zendir-uv-950",
] as const;
